export const ROMAN_DES_URL = 'https://des-apigw-swapi-global.apps.axdesecocp1.ecommerce.inditex.grp/roman';
export const ROMAN_PRE_URL = 'https://pre-apigw-swapi-global.apps.axpreecocp2.ecommerce.inditex.grp/roman';
export const ROMAN_PRO_URL = 'https://apigw.apps.axec1ocp1.ecommerce.inditex.grp/roman';
